/* GeoDomeX store sections - shared runtime.
   Live prices come from Shopify (snippet gdxs-data, per market and currency); the basket is the real
   Shopify cart (Ajax API); grouped Complete Sets use hidden line properties. Namespace: window.GDXS.
   Everything renders inside .gdxs roots so it cannot collide with the theme's own styles or scripts. */
(function () {
  'use strict';
  var G = window.GDXS = window.GDXS || {};
  if (G.coreReady) return;
  G.coreReady = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  G.$ = $; G.$$ = $$;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var D = G.D = readJSON('gdxs-data') || { products: {}, currency: 'GBP', country: 'GB', locale: 'en' };
  G.uk = D.country === 'GB';
  G.gbp = D.currency === 'GBP';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || D.root || '/';
  G.root = ROOT;

  /* live variant index: id -> { p, w, a, h } in presentment currency (major units) */
  var V = G.V = {};
  Object.keys(D.products || {}).forEach(function (h) {
    var p = D.products[h];
    if (!p || !p.variants) return;
    p.variants.forEach(function (v) {
      V[v.id] = { p: v.price / 100, w: Math.max(v.compare || 0, v.price) / 100, a: !!v.available, h: h, t: v.title };
    });
  });

  /* ---------- helpers ---------- */
  var nf = {};
  G.fmt = function (n) {
    if (n === null || n === undefined || isNaN(n)) return '';
    var dec = Math.round(Math.abs(n) * 100) % 100 !== 0, key = dec ? 'd' : 'i';
    if (!nf[key]) {
      var loc = (D.locale || 'en') + '-' + (D.country || 'GB');
      try { nf[key] = new Intl.NumberFormat(loc, { style: 'currency', currency: D.currency || 'GBP', minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 }); }
      catch (e) { nf[key] = new Intl.NumberFormat('en-GB', { style: 'currency', currency: D.currency || 'GBP', minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 }); }
    }
    return nf[key].format(n);
  };
  /* a resized copy from Shopify's image CDN (photos and theme renders alike); w = the pixel width needed */
  G.img = function (u, w) {
    if (!u || !w) return u || '';
    if (/\.(svg|gif|mp4)(\?|$)/i.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    if (/cdn\.shopify\.com|\/cdn\/shop\/|\/t\/\d+\/assets\//.test(u)) return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return u;
  };
  G.q = function (k, d) { var v = new URLSearchParams(location.search).get(k); return v === null ? d : v; };
  G.esc = function (s) { return String(s === undefined || s === null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  G.klarna = function (t) {
    if (!G.uk || !G.gbp || !t) return '';
    return 'or 3 interest-free payments of ' + G.fmt(Math.round(t / 3 * 100) / 100) + ' <i>Klarna.</i>';
  };
  G.url = function (path) { return ROOT.replace(/\/$/, '') + '/' + String(path).replace(/^\//, ''); };

  /* ---------- sale events and the free LED Lighting Kit (23 Oct 2026, owner) ----------
     The kit is part of each sale event (calendars in snippets/gdxs-sale-config.liquid: GB, and the US from 24 Oct 2026):
     while an event runs it shows and goes in the basket free with each dome; when the event ends, as the sale banner goes,
     it goes too. Markets without a calendar keep the kit with every dome. Same timing as gdxs-sale.js (the calendar's own
     days: UK time for GB, US Eastern time for the US, tz in the config; preview ?gdx_sale_at). */
  var saleCal = null;
  G.saleNow = function () {
    var C = window.GDXS_SALE;
    if (!C || !C.events) return null;
    if (!saleCal) {
      var skew = 0;
      try {
        var q = new URLSearchParams(location.search).get('gdx_sale_at');
        if (q && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') { var qt = Date.parse(q); if (!isNaN(qt)) skew = qt - Date.now(); }
      } catch (e) {}
      /* minutes the calendar's time zone (London unless the config says) is ahead of UTC at instant ms */
      var off = function (ms) {
        try {
          var o = {};
          new Intl.DateTimeFormat('en-GB', { timeZone: C.tz || 'Europe/London', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
            .formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
          return Math.round((Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute) - ms) / 60000);
        } catch (e) { return 0; }
      };
      var ukDay = function (s, add) { var a = String(s).split('-'), g = Date.UTC(+a[0], +a[1] - 1, +a[2] + (add || 0)); return g - off(g) * 60000; };
      saleCal = { skew: skew, ev: C.events.map(function (e) { return { n: e[0], s: ukDay(e[1]), e: ukDay(e[1], e[2]) }; }) };
    }
    var t = Date.now() + saleCal.skew;
    for (var i = 0; i < saleCal.ev.length; i++) if (t >= saleCal.ev[i].s && t < saleCal.ev[i].e) return saleCal.ev[i];
    return null;
  };
  G.ledOn = function () { var C = window.GDXS_SALE; return !(C && C.events) || !!G.saleNow(); };
  /* wording about the free kit: none while it is off; with a calendar (GB, US) wrapped so it goes the moment the event ends
     (gdxs-sale.js hides .gdxs-led when no event runs); elsewhere unchanged, so translations still match */
  G.ledTxt = function (html) { return !G.ledOn() ? '' : window.GDXS_SALE ? '<span class="gdxs-led">' + html + '</span>' : html; };

  var I = {
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    bag: '<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    right: '<path d="M9 6l6 6-6 6"/>',
    left: '<path d="M15 6l-6 6 6 6"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
    truck: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/>',
    shield: '<path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
    back: '<path d="M4 12a8 8 0 1 0 3-6.2"/><path d="M4 4v4h4"/>',
    cube: '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/>',
    ar: '<path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3"/><path d="M12 7l4 2.3v4.6L12 16l-4-2.1V9.3z"/>',
    phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1"/>',
    chat: '<path d="M4 5h16v11H9l-5 4z"/>',
    play: '<path d="M7 4l13 8-13 8z" fill="currentColor" stroke="none"/>',
    tools: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>',
    gift: '<path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7H8.5a2 2 0 1 1 0-4C11 3 12 7 12 7zm0 0h3.5a2 2 0 1 0 0-4C13 3 12 7 12 7z"/>',
    lock: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
    star: '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z" fill="currentColor" stroke="none"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
    pin: '<path d="M12 21s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12z"/><circle cx="12" cy="9" r="2.5"/>',
    calc: '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 11h2M12 11h2M16 11h0M8 15h2M12 15h2M8 18h2M12 18h4"/>',
    users: '<circle cx="9" cy="8" r="3"/><path d="M3 20a6 6 0 0 1 12 0"/><circle cx="17" cy="9" r="2.5"/><path d="M15 14.5a5 5 0 0 1 6 4.5"/>',
    box: '<path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/>',
    rotate: '<path d="M8 15.8C5 15.1 3 13.7 3 12c0-2.5 4-4.5 9-4.5s9 2 9 4.5c0 2.2-3.2 4.1-7.6 4.5"/><path d="M15.6 14.2l-2.2 2.3 2.2 2.3"/>'
  };
  G.icon = function (n, cls) {
    return '<svg class="' + (cls || '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (I[n] || '') + '</svg>';
  };
  /* the GeoDomeX logo in place of the brand word in titles (GeoDomeXL product names stay as text) */
  G.wm = function (html, light) {
    return String(html).replace(/GeoDomeX(?!L)/, '<img class="wm" src="' + (D.assetBase || '') + 'gdxs-logo-' + (light ? 'light' : 'dark') + '.png" alt="GeoDomeX" width="767" height="120">');
  };

  /* ---------- delivery promise (14:00 London cut-off, Saturday delivery, a base adds a day, UK holidays) ---------- */
  function londonNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false });
    var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour % 24, m: +p.minute };
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function iso(d) { return d.toISOString().slice(0, 10); }
  G.holidays = G.holidays || {};
  G.delivery = function (hasBase) {
    var H = G.holidays, n = londonNow(), d = n.d, mins = n.h * 60 + n.m, dispatch = d, today = false;
    function workday(x) { var w = x.getUTCDay(); return w >= 1 && w <= 5 && !H[iso(x)]; }
    if (workday(d) && mins < 14 * 60) { today = true; } else {
      do { dispatch = addDays(dispatch, 1); } while (!workday(dispatch));
    }
    var del = dispatch, steps = hasBase ? 2 : 1;
    while (steps > 0) { del = addDays(del, 1); if (del.getUTCDay() !== 0 && !H[iso(del)]) steps--; }
    var lang = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2), label;
    try { label = del.toLocaleDateString(lang === 'en' ? 'en-GB' : lang, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); } catch (e) { label = del.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }
    var left = today ? (14 * 60 - mins) : null;
    var lt = left !== null ? (Math.floor(left / 60) ? Math.floor(left / 60) + 'h ' : '') + (left % 60) + 'm' : null;
    if (!G.uk) return { label: '', left: null, html: 'Free express shipping, tracked to your door' };
    return { label: label, left: lt, html: (lt ? 'Order within <b>' + lt + '</b> for delivery on <b>' + label + '</b>' : 'Order now for delivery on <b>' + label + '</b>') };
  };

  /* ---------- cart (Shopify Ajax API) ---------- */
  function api(path, body) {
    var opt = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(G.url(path), opt).then(function (r) {
      return r.json().catch(function () { var e = new Error('Could not update your basket. Please try again.'); e.status = r.status; throw e; }).then(function (j) {
        if (!r.ok) { var e = new Error((j && (j.description || j.message)) || 'Cart error'); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  var GIFT = 'geodomex-led-lighting-kit';
  function giftVariant() {
    var p = D.products && D.products[GIFT];
    return (p && p.variants && p.variants[0] && p.variants[0].id) || (G.CAT && G.CAT.led && G.CAT.led.v);
  }
  function isGift(it) { var l = V[it.variant_id]; return !!l && l.h === GIFT && Number(it.final_price) === 0; }
  /* every dome earns the free LED kit; legacy dome products (Mini 2.7 m, Standard Ultra+) are known by handle */
  var DOME_HANDLES = ['geodomex-1', 'geodomexlarge', 'geodomexmini', 'geodomex-ultra-3-5m-version'];
  G.DOME_HANDLES = DOME_HANDLES;
  function domeQty(items) {
    return items.reduce(function (a, it) {
      if (isGift(it)) return a;
      var m = G.meta(it.variant_id), dome = m ? (m.kind === 'dome' && m.gift) : DOME_HANDLES.indexOf(it.handle) > -1;
      return a + (dome ? it.quantity : 0);
    }, 0);
  }
  G.cart = {
    state: { items: [], item_count: 0, total_price: 0 },
    busy: false,
    fetch: function () {
      return api('cart.js').then(function (c) { return G.cart.syncCodes(c); }).then(function (c) { G.cart.state = c; G.updateCount(); return c; });
    },
    /* the Complete Set saving codes the basket needs right now (see Complete Set prices below), applied through the
       cart so checkout shows the same prices as the pages; codes the shopper entered are kept. extra: codes to add
       (the hospitality multi-unit code). Resolves with the current cart. */
    syncCodes: function (c, extra) {
      var cfg = G.CAT && G.CAT.setPricing;
      return (c ? Promise.resolve(c) : api('cart.js')).then(function (cart) {
        if (!cfg && !(extra && extra.length)) return cart;
        var up = function (x) { return String(x).toUpperCase(); }, ours = G.setCodeList();
        /* an extra code replaces an older code of the same family (HOSPITALITY4 replaces HOSPITALITY3) */
        var fam = function (x) { return up(x).replace(/\d+$/, ''); }, xf = (extra || []).map(fam);
        var have = (cart.discount_codes || []).map(function (d) { return d.code; });
        var want = have.filter(function (x) { return ours.indexOf(up(x)) < 0 && xf.indexOf(fam(x)) < 0; });
        (extra || []).concat(G.setCodesFor(cart.items)).forEach(function (x) { if (want.map(up).indexOf(up(x)) < 0) want.push(x); });
        if (have.map(up).sort().join(',') === want.map(up).sort().join(',')) return cart;
        return api('cart/update.js', { discount: want.join(',') }).then(function () { return api('cart.js'); }, function () { return cart; });
      }).catch(function () { return c || G.cart.state; });
    },
    /* lines: [{ v, ... }], meta: { label, qty, src } - a label groups the lines as one set in the basket; src 'home'
       marks lines built in the homepage configurator, which sells at full prices (no Complete Set codes, 23 Oct 2026, owner) */
    add: function (lines, meta) {
      meta = meta || {};
      var qty = meta.qty || 1, gid = meta.label ? ('s' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6)) : null;
      var bad = lines.filter(function (l) { return !l || !l.v || l.na; });
      if (bad.length) return Promise.reject(new Error('Part of this selection is unavailable in your region'));
      var items = lines.map(function (l) {
        var it = { id: Number(l.v), quantity: qty }, pr = {};
        if (gid) { pr._gdxs_set = gid; pr._gdxs_label = meta.label; }
        if (meta.src) pr._gdxs_src = meta.src;
        if (gid || meta.src) it.properties = pr;
        return it;
      });
      return api('cart/add.js', { items: items }).then(function () { return G.cart.syncGift(); });
    },
    change: function (key, qty) { return api('cart/change.js', { id: key, quantity: qty }).then(function () { return G.cart.syncGift(); }); },
    update: function (updates) { return api('cart/update.js', { updates: updates }).then(function () { return G.cart.syncGift(); }); },
    lines: function () { return (G.cart.state.items || []); },
    group: function (gid) { return G.cart.lines().filter(function (it) { return it.properties && it.properties._gdxs_set === gid; }); },
    qtyGroup: function (gid, d) {
      var up = {};
      G.cart.group(gid).forEach(function (it) { up[it.key] = Math.max(1, it.quantity + d); });
      return G.cart.update(up);
    },
    removeGroup: function (gid) {
      var up = {};
      G.cart.group(gid).forEach(function (it) { up[it.key] = 0; });
      return G.cart.update(up);
    },
    /* the free LED kit follows the number of eligible domes in the basket (same rule as the homepage configurator) */
    syncGift: function () {
      function done(c) { return G.cart.syncCodes(c).then(function (c2) { G.cart.state = c2; G.updateCount(); G.emit('cart', c2); return c2; }); }
      return api('cart.js').then(function (c) {
        var gv = giftVariant(), want = G.CAT && G.CAT.led && G.CAT.led.active !== false ? domeQty(c.items) : 0;
        var gifts = c.items.filter(isGift), have = gifts.reduce(function (a, it) { return a + it.quantity; }, 0);
        if (!gv || !V[gv] || !V[gv].a || want === have) return done(c);
        var p;
        if (!gifts.length) p = api('cart/add.js', { items: [{ id: Number(gv), quantity: want, properties: { _gdxs_gift: '1' } }] });
        else {
          var up = {}; gifts.forEach(function (it, i) { up[it.key] = i === 0 ? want : 0; });
          p = api('cart/update.js', { updates: up });
        }
        return p.then(function () { return api('cart.js'); }).then(done);
      });
    },
    count: function () {
      return G.cart.lines().reduce(function (a, it) { return a + (isGift(it) ? 0 : it.quantity); }, 0);
    },
    has: function (kind) { return G.cart.lines().some(function (it) { var m = G.meta(it.variant_id); return m && m.kind === kind; }); },
    /* delivery is free for every store item in every market; replacement parts (not store items) are charged */
    freeDelivery: function () { return G.cart.lines().every(function (it) { return !!G.meta(it.variant_id); }); },
    /* a complete set of this size (dome, base and sunshade) already in the basket */
    hasSet: function (size) { return G.setCount(G.cart.lines(), size) > 0; },
    domes: function () { return domeQty(G.cart.lines()); },
    totals: function () {
      var t = 0, w = 0;
      G.cart.lines().forEach(function (it) {
        if (isGift(it)) return;
        var line = it.final_line_price / 100, m = V[it.variant_id];
        t += line;
        w += m ? Math.max(m.w, it.final_price / 100) * it.quantity : (it.original_line_price / 100);
      });
      var total = (G.cart.state.total_price || 0) / 100;
      return { total: total, was: Math.max(w, t), save: Math.max(0, Math.round((w - t) * 100) / 100), items: t };
    },
    isGift: isGift
  };

  /* ---------- tiny event bus ---------- */
  var subs = {};
  G.on = function (ev, fn) { (subs[ev] = subs[ev] || []).push(fn); };
  G.emit = function (ev, data) { (subs[ev] || []).forEach(function (fn) { try { fn(data); } catch (e) { if (window.console) console.error(e); } }); };

  /* catalogue metadata for a variant (kind, size, title, image), filled by gdxs-catalogue.js */
  G.metaIndex = G.metaIndex || {};
  G.meta = function (vid) { return G.metaIndex[String(vid)] || null; };

  /* ---------- header cart counts (theme header + store sections) ---------- */
  G.updateCount = function () {
    var n = G.cart.count();
    $$('[data-gdxs-count]').forEach(function (e) { e.textContent = n ? n : ''; e.hidden = !n; });
    $$('.cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
      if (s) s.textContent = n;
      b.hidden = !n; b.style.display = n ? '' : 'none';
    });
    $$('.custom-header-cart-text').forEach(function (e) { e.textContent = 'Basket (' + n + ')'; });
    $$('.custom-header-mobile-util').forEach(function (a) {
      if (/\/cart\/?$/.test(a.getAttribute('href') || '')) { var sp = a.querySelector('span'); if (sp) sp.textContent = 'Basket (' + n + ')'; }
    });
    if (document.body && document.body.classList.contains('gdxs-store')) {
      $$('.custom-header-cart').forEach(function (a) {
        var bd = a.querySelector('.gdxs-hcount');
        if (!bd) { bd = document.createElement('span'); bd.className = 'gdxs-hcount'; bd.setAttribute('aria-hidden', 'true'); a.appendChild(bd); }
        bd.textContent = n; bd.hidden = !n;
        a.setAttribute('aria-label', 'Basket, ' + n + (n === 1 ? ' item' : ' items'));
      });
    }
    /* the menu's Basket (n) follows the basket too (it was the page-load count) */
    $$('.custom-header-mobile-util').forEach(function (a) { var sp = a.querySelector('span'); if (sp && /\(\d+\)/.test(sp.textContent)) sp.textContent = sp.textContent.replace(/\(\d+\)/, '(' + n + ')'); });
    document.documentElement.classList.toggle('gdxs-has-cart', n > 0);
  };

  /* ---------- drawer, toast, video modal (mounted once, inside a .gdxs wrapper) ---------- */
  function mountShell() {
    if (document.getElementById('gdxs-shell')) return;
    var w = document.createElement('div');
    w.className = 'gdxs gdxs-shell';
    w.id = 'gdxs-shell';
    w.innerHTML = '<div class="overlay" id="gdxs-overlay"></div>' +
      '<aside class="drawer" id="gdxs-drawer" role="dialog" aria-modal="true" aria-label="Basket" tabindex="-1"><div class="drawer-h"><b>Your basket</b><button class="x" id="gdxs-bag-close" aria-label="Close basket">' + G.icon('close') + '</button></div>' +
      '<div class="drawer-b" id="gdxs-drawer-body"></div><div class="drawer-f" id="gdxs-drawer-foot"></div></aside>' +
      '<div class="toast" id="gdxs-toast" role="status" aria-live="polite"></div>' +
      '<div class="modal" id="gdxs-modal" role="dialog" aria-modal="true" aria-label="Video"><div class="box"><button class="x" id="gdxs-modal-close" aria-label="Close video">' + G.icon('close') + '</button><video controls playsinline preload="none"></video></div></div>';
    document.body.appendChild(w);
    $('#gdxs-bag-close').onclick = G.closeDrawer;
    $('#gdxs-overlay').onclick = G.closeDrawer;
    $('#gdxs-modal-close').onclick = function () { var v = $('#gdxs-modal video'); v.pause(); $('#gdxs-modal').classList.remove('open'); };
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { G.closeDrawer(); var m = $('#gdxs-modal'); if (m && m.classList.contains('open')) $('#gdxs-modal-close').click(); }
    });
  }

  /* the discount codes on a basket line (the cart gives a code as the discount's key, and usually as its title) */
  function lineCodes(it) {
    var out = [];
    (it.line_level_discount_allocations || []).forEach(function (d) {
      var a = d && d.discount_application; if (!a) return;
      [a.key, a.title].forEach(function (x) { if (x) out.push(String(x).toUpperCase()); });
    });
    return out;
  }
  /* the part of a line's discounts that comes from the store's Complete Set codes (in pence; the sunshade carries them).
     Built for you booked with a set keeps its own code and shows its set price on its own line, as before. */
  function setOff(it) {
    var c = G.CAT && G.CAT.setPricing, ours = c ? Object.keys(c.sets).map(function (k) { return String(c.sets[k].code).toUpperCase(); }).concat(c.base ? Object.keys(c.base).map(function (k) { return String(c.base[k].code).toUpperCase(); }) : []) : [], t = 0;
    (it.line_level_discount_allocations || []).forEach(function (d) {
      var a = d && d.discount_application; if (!a) return;
      if ([a.key, a.title].some(function (x) { return x && ours.indexOf(String(x).toUpperCase()) > -1; })) t += Number(d.amount) || 0;
    });
    return t;
  }
  function setSaveRow(p) {
    return p > 0 ? '<div class="line setsave"><span class="sv-ic">' + G.icon('check') + '</span><div class="meta"><b>Complete Set saving</b></div><div class="amt">\u2212' + G.fmt(p / 100) + '</div></div>' : '';
  }
  function lineHTML(it) {
    var m = G.meta(it.variant_id) || {}, lv = V[it.variant_id];
    var img = m.img ? G.img(m.img, 240) : (it.image ? G.img(it.image, 240) : '');
    var title = m.title || it.product_title, sub = G.esc(m.sub || (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''));
    /* the homepage configurator books a Large build as two Mini/Standard installation units marked "Dome Size: Large" */
    if (m.kind === 'assembly' && m.size !== 'large' && it.properties && it.properties['Dome Size'] === 'Large') title = 'Built for you · Large';
    /* 22 Oct 2026 (owner): a part of a Complete Set shows at its full price; the set saving is one row under the set */
    var was = lv ? lv.w * it.quantity : 0, now = (it.final_line_price + setOff(it)) / 100;
    var grouped = it.properties && it.properties._gdxs_set;
    var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k] !== '' && it.properties[k] != null; })
      .map(function (k) { return G.esc(k) + ': ' + G.esc(String(it.properties[k])); }).join(' · ');
    if (props) sub = sub ? sub + ' · ' + props : props;
    /* a line carrying one of the store's Complete Set codes, or a hospitality multi-unit code, says so */
    var codes = lineCodes(it), ours = G.setCodeList();
    if (m.kind === 'assembly' && codes.some(function (x) { return ours.indexOf(x) > -1; })) sub = (sub ? sub + ' · ' : '') + 'with your Complete Set';
    if (codes.some(function (x) { return /^HOSPITALITY\d+$/.test(x); })) sub = (sub ? sub + ' · ' : '') + 'Multi-unit saving';
    return '<div class="line"><img src="' + G.esc(img) + '" alt="" loading="lazy"><div class="meta"><b>' + G.esc(title) + '</b><small>' + sub + '</small>' +
      (grouped ? '' : '<div class="actions"><span class="qty" style="height:32px"><button type="button" data-gk="' + it.key + '" data-d="-1" aria-label="Fewer">−</button><span>' + it.quantity + '</span><button type="button" data-gk="' + it.key + '" data-d="1" aria-label="More">+</button></span><button type="button" class="tiny" data-gr="' + it.key + '" style="text-decoration:underline">Remove</button></div>') +
      '</div><div class="amt">' + G.fmt(now) + (was > now + 0.001 ? '<s>' + G.fmt(was) + '</s>' : '') + '</div></div>';
  }
  G.linesHTML = function (items, opts) {
    opts = opts || {};
    var html = '', seen = {}, loose = 0;
    items.forEach(function (it) {
      if (isGift(it)) return;
      var gid = it.properties && it.properties._gdxs_set;
      if (gid) {
        if (seen[gid]) return;
        seen[gid] = 1;
        var grp = items.filter(function (x) { return x.properties && x.properties._gdxs_set === gid; }), q = grp[0].quantity, off = 0;
        html += '<div class="set-head"><span>' + G.esc(it.properties._gdxs_label || 'Complete Set') + (q > 1 ? ' × ' + q : '') + '</span><span class="row" style="gap:10px"><span class="qty" style="height:32px"><button type="button" data-gq="' + gid + '" data-d="-1" aria-label="Fewer sets">−</button><span>' + q + '</span><button type="button" data-gq="' + gid + '" data-d="1" aria-label="More sets">+</button></span><button type="button" data-rg="' + gid + '">Remove</button></span></div>';
        grp.forEach(function (x) { html += lineHTML(x); off += setOff(x); });
        html += setSaveRow(off);
        return;
      }
      html += lineHTML(it); loose += setOff(it);
    });
    /* a set bought as separate parts: its saving after the lines */
    html += setSaveRow(loose);
    var gifts = items.filter(isGift);
    if (gifts.length && G.CAT && G.CAT.led) {
      var n = gifts.reduce(function (a, it) { return a + it.quantity; }, 0), led = G.CAT.led, lw = V[led.v] ? V[led.v].w : led.w;
      html += '<div class="line gift' + (window.GDXS_SALE ? ' gdxs-led' : '') + '"><img src="' + G.img(led.img, 200) + '" alt="" loading="lazy"><div class="meta"><b>' + G.esc(led.title) + (n > 1 ? ' × ' + n : '') + '</b><small>Free with every eligible dome</small></div><div class="amt">Free' + (lw ? '<s>' + G.fmt(lw * n) + '</s>' : '') + '</div></div>';
    }
    return html;
  };
  G.bindLines = function (root, after) {
    function run(p) { root.classList.add('is-busy'); p.catch(function (e) { G.toast(e.message || 'Something went wrong'); }).then(function () { root.classList.remove('is-busy'); if (after) after(); }); }
    $$('[data-gq]', root).forEach(function (x) { x.onclick = function () { G.justAdded = null; run(G.cart.qtyGroup(x.dataset.gq, +x.dataset.d)); }; });
    $$('[data-rg]', root).forEach(function (x) { x.onclick = function () { G.justAdded = null; run(G.cart.removeGroup(x.dataset.rg)); }; });
    $$('[data-gk]', root).forEach(function (x) {
      x.onclick = function () {
        G.justAdded = null;
        var it = G.cart.lines().filter(function (l) { return l.key === x.dataset.gk; })[0]; if (!it) return;
        run(G.cart.change(it.key, Math.max(1, it.quantity + (+x.dataset.d))));
      };
    });
    $$('[data-gr]', root).forEach(function (x) { x.onclick = function () { G.justAdded = null; run(G.cart.change(x.dataset.gr, 0)); }; });
  };

  G.renderDrawer = function () {
    var b = $('#gdxs-drawer-body'), f = $('#gdxs-drawer-foot'); if (!b) return;
    var items = G.cart.lines();
    var real = items.filter(function (it) { return !isGift(it); });
    if (!real.length) {
      b.innerHTML = '<div class="empty">' + G.icon('bag') + '<b style="color:var(--ink);display:block;font-size:16px">Your basket is empty</b>' +
        (G.uk && G.setSaveLine() ? '<p class="small">' + G.setSaveLine() + '</p>' : '') + '<a class="btn btn-primary" href="' + G.url('collections/all') + '" style="margin-top:8px">Shop GeoDomeX</a></div>';
      f.innerHTML = ''; return;
    }
    var html = (G.justAdded ? '<div class="added-note" role="status">' + G.icon('check') + '<span>' + G.esc(G.justAdded) + ' added to your basket</span></div>' : '') + G.linesHTML(items);
    /* one smart upsell */
    var up = '', C = G.CAT, dl = real.filter(function (it) { var m = G.meta(it.variant_id); return m && m.kind === 'dome'; })[0], dome = dl && G.meta(dl.variant_id);
    if (C && dome && G.uk && !G.cart.has('assembly')) {
      var hasBase = G.cart.has('base'), withSet = hasBase && G.cart.hasSet(dome.size), a = G.assemblyFor(dome.size, hasBase ? 'bundle' : 'dome', 'std', null, withSet);
      if (a && !a.na) up = '<div class="upsell"><img src="' + G.img(C.assembly.img[0], 200) + '" alt=""><div class="t"><b>Built for you, from ' + G.fmt(a.p) + (a.setSave ? ' with your set' : '') + '</b>Our installers build ' + (hasBase ? 'the base and dome' : 'the dome') + ' and anchor it, within 14 working days.' + (withSet && G.setBaseSave(dome.size) ? ' <span class="save-note">' + G.baseSaveTxt(dome.size) + '</span>' : '') + '</div><a class="add-ic" href="' + G.esc(C.urls.assembly) + '?size=' + dome.size + (hasBase ? '&scope=bundle' : '') + '" aria-label="Check your postcode for Built for you">' + G.icon('right') + '</a></div>';
    } else if (C && dome && !G.cart.has('shade')) {
      /* with a base of the same size in the basket, the sunshade completes a set (not for a homepage build, which is at full prices) */
      var s = C.sizes[dome.size] && C.sizes[dome.size].shade, completes = !G.homeLine(dl) && real.some(function (it) { var mm = G.meta(it.variant_id); return mm && mm.kind === 'base' && mm.size === dome.size && !G.homeLine(it); }) && !(dome.size === 'mini' && dome.spec === 'original'), off = completes ? G.setSave(dome.size) : 0;
      if (s && !s.na) up = '<div class="upsell"><img src="' + G.img(G.shadeRender(dome.size, 'grey', 'right'), 300) + '" alt=""><div class="t"><b>Add sunshade privacy panels, ' + G.fmt(s.p) + '</b>' + (off ? 'Makes it a Complete Set: you save ' + G.fmt(off) + '. ' : '') + 'Individual panels for the back and both sides. Pick and choose which to cover. Four colours.</div><a class="add-ic" href="' + G.esc(s.url || '#') + '" aria-label="Choose a sunshade">' + G.icon('right') + '</a></div>';
    }
    b.innerHTML = html + up;
    var t = G.cart.totals();
    f.innerHTML = (t.save > 0 ? '<div class="sumrow save"><span>You save</span><span>' + G.fmt(t.save) + '</span></div>' : '') +
      '<div class="sumrow"><span>Delivery</span><span data-i18n-ctx="delivery">' + (G.cart.freeDelivery() ? 'Free' : 'Calculated at checkout') + '</span></div>' +
      '<div class="sumrow total"><span>Total</span><span>' + G.fmt(t.total) + '</span></div>' +
      (G.klarna(t.total) ? '<div class="klarna" style="margin:2px 0 12px">' + G.klarna(t.total) + '</div>' : '<div style="height:10px"></div>') +
      '<a class="btn btn-primary btn-block btn-lg" href="' + G.url('checkout') + '">' + G.icon('lock') + 'Checkout securely</a>' +
      '<div class="tiny center" style="margin-top:9px">' + G.delivery(G.cart.has('base')).html + '</div>';
    G.bindLines(b, G.renderDrawer);
  };
  var lastFocus = null;
  G.openDrawer = function () {
    mountShell();
    G.renderDrawer();
    lastFocus = document.activeElement;
    $('#gdxs-drawer').classList.add('open');
    $('#gdxs-overlay').classList.add('show');
    document.documentElement.classList.add('gdxs-lock');
    setTimeout(function () { var d = $('#gdxs-drawer'); if (d) d.focus(); }, 60);
    G.cart.fetch().then(G.renderDrawer);
  };
  G.closeDrawer = function () {
    G.justAdded = null;
    var d = $('#gdxs-drawer'); if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open');
    $('#gdxs-overlay').classList.remove('show');
    document.documentElement.classList.remove('gdxs-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  G.addAndOpen = function (lines, meta) {
    var btns = $$('[data-gdxs-adding]');
    btns.forEach(function (b) { b.disabled = true; });
    return G.cart.add(lines, meta).then(function () {
      G.justAdded = (meta && meta.label) ? meta.label : (lines[0] && lines[0].title) || 'Item';
      setTimeout(G.openDrawer, 120);
    }).catch(function (e) {
      G.toast(e.message || 'Could not add to basket');
    }).then(function () { btns.forEach(function (b) { b.disabled = false; }); });
  };
  G.on('cart', function () { var d = $('#gdxs-drawer'); if (d && d.classList.contains('open')) G.renderDrawer(); });

  var tt;
  G.toast = function (msg) {
    mountShell();
    var t = $('#gdxs-toast'); if (!t) return;
    t.innerHTML = G.icon('check') + G.esc(msg); t.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2600);
  };
  /* ---------- live chat and the Talk to the team card (23 Oct 2026, owner) ----------
     openChat opens the HubSpot chat as the Live Chat card in the team section does (a tap overrides the quiet-hours
     bubble gate; HubSpot's away state handles out-of-hours visitors). If the chat cannot load, the phone number shows. */
  var chatQueued = false, chatLoaded = null;
  G.openChat = function () {
    var hider = document.getElementById('chat-widget-hider'); if (hider) hider.remove();
    function go() {
      chatQueued = false;
      var conv = window.HubSpotConversations, w = conv && conv.widget;
      if (!w) return;
      if (w.status().loaded) { w.open(); return; }
      if (!chatLoaded) {
        chatLoaded = function () { conv.off('widgetLoaded', chatLoaded); chatLoaded = null; var cur = window.HubSpotConversations; if (cur && cur.widget) cur.widget.open(); };
        conv.on('widgetLoaded', chatLoaded);
      }
      w.load({ widgetOpen: true });
    }
    if (window.HubSpotConversations && window.HubSpotConversations.widget) go();
    else if (!chatQueued) { chatQueued = true; window.hsConversationsOnReady = (window.hsConversationsOnReady || []).concat(go); }
    setTimeout(function () {
      var c = window.HubSpotConversations, w = c && c.widget, ok = false;
      try { ok = document.documentElement.classList.contains('hs-messages-widget-open') || !!(w && w.status && w.status().loaded); } catch (e) {}
      if (!ok) G.toast('Live chat is not loading. Call us on ' + ((G.CAT && G.CAT.phone) || '020 3886 1874') + '.');
    }, 6000);
  };
  document.addEventListener('click', function (e) { var b = e.target && e.target.closest && e.target.closest('[data-gdxs-chat]'); if (b) { e.preventDefault(); G.openChat(); } });
  /* the card: the number on its own line (never split), Call us and Live chat side by side */
  G.teamCard = function () {
    var ph = (G.CAT && G.CAT.phone) || '020 3886 1874';
    return '<div class="learn learn-team"><div><b>Talk to the team</b><span>Questions about sizing, ground or delivery?</span>' +
      '<span>Call ' + ph.replace(/ /g, ' ') + ', Monday to Friday' + (G.uk ? '' : ', UK time') + '.</span>' +
      '<span class="learn-acts"><a class="learn-call" href="tel:' + ph.replace(/ /g, '') + '">' + G.icon('phone') + 'Call us</a>' +
      '<button type="button" class="learn-chat" data-gdxs-chat>' + G.icon('chat') + 'Live chat</button></span></div></div>';
  };
  G.playVideo = function (src, poster) {
    mountShell();
    var m = $('#gdxs-modal'), v = $('#gdxs-modal video'); m.classList.remove('tall');
    v.onloadedmetadata = function () { m.classList.toggle('tall', v.videoHeight > v.videoWidth); };
    v.src = src; if (poster) v.poster = poster; m.classList.add('open'); v.play().catch(function () { });
  };

  /* ---------- gallery and sticky bars ---------- */
  G.gallery = function (root, onChange) {
    var tr = $('.gal-track', root), dots = $('.gal-dots', root), cur = -1; if (!tr) return null;
    var n = tr.children.length; if (dots) dots.innerHTML = new Array(n + 1).join('<i></i>');
    /* a photo that fails to load is dropped from the gallery rather than shown broken */
    function dropBroken(im) {
      var sl = im; while (sl && sl.parentNode !== tr) sl = sl.parentNode;
      if (!sl || tr.children.length < 2) return;
      tr.removeChild(sl);
      if (dots) dots.innerHTML = new Array(tr.children.length + 1).join('<i></i>');
      cur = -1; upd();
    }
    $$('img', tr).forEach(function (im) {
      if (im.complete && im.getAttribute('src') && im.naturalWidth === 0) { dropBroken(im); return; }
      im.addEventListener('error', function () { dropBroken(im); });
    });
    /* the next two slides load ahead of the swipe, so a lazily loaded photo is never caught half drawn */
    function warm(to) { for (var k = 0; k <= Math.min(to, tr.children.length - 1); k++) { var im = $('img[loading="lazy"]', tr.children[k]); if (im) im.loading = 'eager'; } }
    function upd() {
      var i = Math.round(tr.scrollLeft / tr.clientWidth); warm(i + 2); if (dots) $$('i', dots).forEach(function (d, k) { d.classList.toggle('on', k === i); }); $$('.thumbs button', root.parentNode).forEach(function (b, k) { b.classList.toggle('on', k === i); });
      if (i !== cur) { cur = i; if (onChange) onChange(i); }
    }
    function go(k) { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
    /* left and right arrows (desktop), as well as swipe, dots and thumbnails */
    if (n > 1 && !$('.spin-nav', root)) ['prev', 'next'].forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'spin-nav ' + c;
      b.setAttribute('aria-label', c === 'prev' ? 'Previous image' : 'Next image'); b.innerHTML = G.icon(c === 'prev' ? 'left' : 'right');
      b.onclick = function () { var i = Math.max(cur, 0), m = tr.children.length; go(c === 'prev' ? (i <= 0 ? m - 1 : i - 1) : (i >= m - 1 ? 0 : i + 1)); };
      root.appendChild(b);
    });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true }); upd();
    $$('.thumbs button', root.parentNode).forEach(function (b, k) { b.onclick = function () { go(k); }; });
    return { go: go, index: function () { return Math.max(cur, 0); } };
  };
  G.stickyFor = function (target, bar) {
    if (!target || !bar || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('gdxs-has-sticky');
    new IntersectionObserver(function (e) { bar.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(target);
  };

  /* ---------- shared blocks ---------- */
  G.ratingHTML = function (light) {
    var r = (G.CAT && G.CAT.rating) || { score: '4.8/5', count: '1,000+ reviews' };
    return '<span class="rating"' + (light ? ' style="color:rgba(255,255,255,.85)"' : '') + '><span class="stars" aria-hidden="true">★★★★★</span><b' + (light ? ' style="color:#fff"' : '') + '>' + r.score + '</b> · ' + r.count + '</span>';
  };
  G.trustHTML = function () {
    return '<div class="trust">' +
      (G.uk ? '<div class="t">' + G.icon('truck') + '<div><b>Next-day delivery</b><span>Free from UK stock</span></div></div>' : '<div class="t">' + G.icon('truck') + '<div><b>Free express shipping</b><span>Tracked to your door</span></div></div>') +
      '<div class="t">' + G.icon('back') + '<div><b>30-day money back</b><span>Love it or return it</span></div></div>' +
      '<div class="t">' + G.icon('shield') + '<div><b>Lifetime parts</b><span>Spare parts at cost, for life</span></div></div>' +
      (G.uk ? '<div class="t">' + G.icon('lock') + '<div><b>Pay in 3</b><span>Klarna, Apple Pay, Shop Pay</span></div></div>' : '<div class="t">' + G.icon('lock') + '<div><b>Secure checkout</b><span>Apple Pay, Shop Pay and cards</span></div></div>') + '</div>';
  };
  G.videoReviewsHTML = function () {
    var C = G.CAT;
    return '<div class="rev-strip">' + C.videoReviews.filter(function (r) { return r.src && r.src.indexOf('http') === 0; }).map(function (r) {
      if (r.feat) return '<button type="button" class="vrev feat" data-video="' + G.esc(r.src) + '" data-poster="' + G.esc(G.img(r.poster, 600)) + '"><img src="' + G.esc(G.img(r.poster, 500)) + '" alt="GeoDomeX owners in their own words" loading="lazy"><span class="play">' + G.icon('play') + '</span><span class="cap"><span class="ft">' + G.esc(r.n) + '</span>' + G.esc(r.t) + '</span></button>';
      return '<button type="button" class="vrev" data-video="' + G.esc(r.src || C.media.introVideo) + '" data-poster="' + G.esc(G.img(r.poster, 600)) + '"><img src="' + G.esc(G.img(r.poster, 500)) + '" alt="' + G.esc(r.n) + ' GeoDomeX owner video" loading="lazy"><span class="play">' + G.icon('play') + '</span><span class="cap">“' + G.esc(r.t) + '”<b>' + G.esc(r.n) + ' · <span class="verified" style="color:#8fe0b6">' + G.icon('check') + 'Verified owner</span></b></span></button>';
    }).join('') + C.reviews.map(function (r) {
      /* photo reviews read like the video cards (round 4): the owner's photo fills the card, the review and name sit at the bottom */
      return '<figure class="trev"><img src="' + G.esc(G.img(r.i, 600)) + '" alt="' + G.esc(r.n) + '\u2019s GeoDomeX" loading="lazy">' + (r.tag ? '<span class="tag">' + G.esc(r.tag) + '</span>' : '') + '<figcaption class="cap"><span class="stars" aria-label="5 out of 5 stars">★★★★★</span>“' + G.esc(r.t) + '”<b>' + G.esc(r.n) + ' · <span class="verified">' + G.icon('check') + 'Verified buyer</span></b></figcaption></figure>';
    }).join('') + '</div>';
  };
  G.bindVideos = function (root) { $$('[data-video]', root).forEach(function (b) { b.onclick = function () { G.playVideo(b.dataset.video, b.dataset.poster); }; }); };

  /* ---------- product logic (same rules as the homepage configurator) ---------- */
  function CAT() { return G.CAT; }
  G.renderFor = function (size, floor, colour) {
    var C = CAT(), code = C.sizes[size].code;
    var v = C.cdn.RV || '';
    if (floor && colour) return C.cdn.R + 'set-' + code + '-' + floor + '-' + colour + '.webp' + v;
    if (floor) return C.cdn.R + 'floor-' + code + '-' + floor + '.webp' + v;
    return C.cdn.R + 'dome-' + code + '.webp' + v;
  };
  /* a sunshade is shown on the dome alone, never on a base; place (back, leftback, right) shows a partial fit */
  G.shadeRender = function (size, colour, place) {
    var C = CAT();
    return C.cdn.R + 'shade-' + C.sizes[size].code + '-' + (C.colours[colour] ? colour : 'grey') + (place ? '-' + place : '') + '.webp' + (C.cdn.RV || '');
  };
  /* one set of individual panels, fitted where the owner wants them: the examples shown with every sunshade.
     One side is shown first (the dome reads open, the panels read as a choice); the full set is always the last option */
  G.FITS = [
    { k: 'right', name: 'One side', long: 'One side only' },
    { k: 'back', name: 'Back', long: 'Back only' },
    { k: 'leftback', name: 'Back + side', long: 'Back and one side' },
    { k: 'roof', name: 'Roof', long: 'Roof canopy only' },
    { k: 'mix', name: 'Pattern', long: 'Any pattern you choose' },
    { k: '', name: 'Full set', long: 'Back and both sides' }
  ];
  G.FIT_ZONES = { back: 'back', leftback: 'left,back', right: 'right', roof: 'roof', mix: 'left,back,right', '': 'left,back,right' };
  /* 23 Oct 2026 (owner: the preview must match every combination): the sides a shopper previews (product and 3D pages),
     and the studio picture for each of the 15 mixes (sorted zone names -> the render's place) */
  G.ZONES = ['left', 'back', 'right', 'roof'];
  G.ZONE_PLACE = { right: 'right', back: 'back', 'back,left': 'leftback', roof: 'roof', 'back,left,right': '', left: 'left', 'left,right': 'leftright',
    'back,right': 'backright', 'back,roof': 'backroof', 'left,roof': 'leftroof', 'right,roof': 'rightroof', 'back,left,roof': 'leftbackroof',
    'left,right,roof': 'leftrightroof', 'back,right,roof': 'backrightroof', 'back,left,right,roof': 'fullroof' };
  G.zonePlace = function (zones) { var k = (zones || []).slice().sort().join(','); return Object.prototype.hasOwnProperty.call(G.ZONE_PLACE, k) ? G.ZONE_PLACE[k] : 'right'; };
  G.SHADE_FIT = 'The set arrives as individual panels for the back and both sides. Pick and choose which panels to cover: every panel for full shade and privacy, or only some, with the rest left clear for the view.';
  /* the sunshade picker on the product and 3D pages (23 Oct 2026, owner): the i explainer and the line under the preview,
     so nobody thinks they only get the side the preview shows */
  G.SHADE_SET = 'You receive the full set: panels for the back and both sides of the dome. The preview shows only the sides you choose to see. Fit every panel, or only the ones you want.';
  G.SHADE_FULL = 'Full set included: back and both sides.';

  /* ---------- every side of a studio render as a simple swipe gallery: front, right side, back, left side ---------- */
  var VIEWS = [['', 'front'], ['-r90', 'right side'], ['-r180', 'back'], ['-r270', 'left side']];
  G.turnViews = function (src) {
    var m = String(src || '').match(/^(.*gdxs-r-(?:dome|set|floor|shade)-\d\d(?:-[a-z]+)*)\.webp(?:\?.*)?$/);
    if (!m) return null;
    var v = (G.CAT && G.CAT.cdn && G.CAT.cdn.RV) || '';
    return VIEWS.map(function (t) { return m[1] + t[0] + '.webp' + v; });
  };
  G.viewName = function (i) { return VIEWS[i] ? VIEWS[i][1] : ''; };
  /* 24 Oct 2026: a side view's description in the shopper's language: the whole description when the dictionary has it,
     otherwise the photo's description and the side each translated, so no page mixes two languages */
  G.sideAlt = function (alt, i) {
    var T = window.GDXS_T, E = window.GDXS_EN, en = alt && E ? E(alt) : alt, v = G.viewName(i), whole = (en ? en + ', ' : '') + v;
    if (!T) return whole;
    var t = T(whole);
    return t !== whole ? t : (en ? T(en) + ', ' : '') + T(v);
  };
  G.sideLabel = function (alt, i, n) {
    var T = window.GDXS_T || function (s) { return s; }, E = window.GDXS_EN || function (s) { return s; };
    return (alt ? T(E(alt)) + ': ' : '') + (n > 1 ? T(G.viewName(i)) + ', ' + T((i + 1) + ' of 4') : T('front'));
  };
  /* turn the front image of a card into a swipe gallery of its four sides; the card keeps setting the front image
     (colour, base, specification) and the other sides follow it, staying on the side being looked at.
     22 Oct 2026 (owner): the sides go round and round like a 3D turn. A copy of the left side sits before the front and a
     copy of the front after the left side; when a swipe settles on a copy the track jumps, unseen, to the real side. */
  G.spin = function (img) {
    if (!img || img._spin) return img && img._spin;
    var host = img.parentNode, tr = document.createElement('div'), slides = [img], cur = 0, n = 1, warmed = false, settle = 0, lastW = 0;
    tr.className = 'spin-track'; tr.tabIndex = 0;
    tr.setAttribute('role', 'group'); tr.setAttribute('aria-roledescription', 'gallery');
    host.classList.add('spin'); host.insertBefore(tr, img); tr.appendChild(img);
    for (var k = 1; k < 4; k++) { var s = document.createElement('img'); s.alt = ''; s.decoding = 'async'; s.draggable = false; tr.appendChild(s); slides.push(s); }
    function ghost() { var g = document.createElement('img'); g.alt = ''; g.decoding = 'async'; g.draggable = false; g.className = 'spin-ghost'; g.setAttribute('aria-hidden', 'true'); g.hidden = true; return g; }
    var gHead = ghost(), gTail = ghost();
    tr.insertBefore(gHead, img); tr.appendChild(gTail);
    var dots = document.createElement('div'); dots.className = 'spin-dots'; dots.setAttribute('aria-hidden', 'true'); dots.innerHTML = '<i></i><i></i><i></i><i></i>';
    function nav(cls, icon, label) { var b = document.createElement('button'); b.type = 'button'; b.className = 'spin-nav ' + cls; b.setAttribute('aria-label', label); b.innerHTML = G.icon(icon); host.appendChild(b); return b; }
    host.appendChild(dots);
    var prev = nav('prev', 'left', 'Previous side'), next = nav('next', 'right', 'Next side');
    function warm() {
      if (warmed) return; warmed = true;
      slides.concat([gHead, gTail]).forEach(function (sl) { if (sl.dataset.src) { sl.src = sl.dataset.src; sl.removeAttribute('data-src'); } });
    }
    /* track position p: with four sides, 0 is the copy of the left side, 1-4 the real sides, 5 the copy of the front */
    function off() { return n > 1 ? 1 : 0; }
    /* the slide width as laid out: the track's scroll width over its slides (clientWidth rounds to whole pixels, and the
       error grows with each slide, so the copies at the ends would never be recognised) */
    function W() { var k = 0; for (var c = tr.firstElementChild; c; c = c.nextElementSibling) if (!c.hidden) k++; return k ? tr.scrollWidth / k : 0; }
    function pos() { var w = W() || 1; return Math.round(tr.scrollLeft / w); }
    function jump(p) { var w = W(); if (w) tr.scrollLeft = p * w; }
    function wrap() {
      if (n < 2) return;
      var w = W(); if (!w) return;
      var p = Math.round(tr.scrollLeft / w);
      if (Math.abs(tr.scrollLeft - p * w) > 1.5) return; /* still moving, or held part way */
      if (p <= 0) jump(4); else if (p >= 5) jump(1);
    }
    function upd() {
      /* the side shown comes from the scroll position once the track is laid out; before that it stays as it was */
      if (W()) cur = n > 1 ? (Math.min(5, Math.max(0, pos())) + 3) % 4 : 0;
      var i = cur;
      $$('i', dots).forEach(function (d, j) { d.classList.toggle('on', j === i); });
      tr.setAttribute('aria-label', G.sideLabel(img.alt, i, n));
      if (n > 1 && W()) { window.clearTimeout(settle); settle = window.setTimeout(wrap, 140); }
    }
    function toPos(p) { warm(); tr.scrollTo({ left: p * W(), behavior: 'smooth' }); }
    function go(i) { toPos(i + off()); }
    function step(d) {
      var p = pos();
      if (n > 1) { if (p <= 0) { jump(4); p = 4; } else if (p >= 5) { jump(1); p = 1; } }
      toPos(Math.max(0, Math.min(n > 1 ? 5 : 0, p + d)));
    }
    prev.onclick = function () { step(-1); };
    next.onclick = function () { step(1); };
    tr.addEventListener('scroll', function () { warm(); window.requestAnimationFrame(upd); }, { passive: true });
    if ('onscrollend' in window) tr.addEventListener('scrollend', wrap);
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (e) { host.addEventListener(e, warm, { passive: true, once: true }); });
    if ('IntersectionObserver' in window) {
      var t = 0, io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { window.clearTimeout(t); if (e.isIntersecting) t = window.setTimeout(function () { warm(); io.disconnect(); }, 1500); });
      }, { threshold: 0.6 });
      io.observe(host);
    }
    /* the track starts on the front, and stays on the side being looked at when it is laid out again (first shown, or resized) */
    function place() { var w = W(); if (w && w !== lastW) { lastW = w; jump(cur + off()); } else if (!w) lastW = 0; }
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(tr);
    function sync() {
      var v = G.turnViews(img.getAttribute('src')), had = n;
      n = v ? 4 : 1; host.classList.toggle('spin-one', !v);
      for (var j = 1; j < 4; j++) {
        var sl = slides[j]; sl.hidden = !v;
        if (!v) continue;
        if (warmed) { if (sl.getAttribute('src') !== v[j]) sl.src = v[j]; } else sl.dataset.src = v[j];
        sl.alt = G.sideAlt(img.alt, j);
      }
      gHead.hidden = gTail.hidden = !v;
      if (v) {
        var front = img.getAttribute('src');
        if (warmed) { if (gHead.getAttribute('src') !== v[3]) gHead.src = v[3]; if (gTail.getAttribute('src') !== front) gTail.src = front; }
        else { gHead.dataset.src = v[3]; gTail.dataset.src = front; }
      }
      if (!v) { cur = 0; if (tr.scrollLeft) tr.scrollLeft = 0; }
      else if (had !== n) jump(cur + 1);
      upd();
    }
    if ('MutationObserver' in window) new MutationObserver(sync).observe(img, { attributes: true, attributeFilter: ['src', 'alt'] });
    sync();
    img._spin = { go: go, index: function () { return cur; }, sync: sync };
    return img._spin;
  };
  /* platform bases pair with Ultra and Extreme; decking fits every specification; bases are UK-only */
  G.floorAllowed = function (size, spec, floor) {
    if (!G.uk) return false; /* bases (and so Complete Sets) are sold to UK shoppers only */
    var s = CAT().sizes[size];
    if (!s.floors[floor] || s.floors[floor].na) return false;
    if (spec === 'original' && floor !== 'decking') return false;
    return true;
  };
  G.firstFloor = function (size, spec, pref) {
    if (pref && G.floorAllowed(size, spec, pref)) return pref;
    var o = CAT().floorOrder.filter(function (f) { return G.floorAllowed(size, spec, f); });
    return o[0] || null;
  };
  G.domeLine = function (size, spec) {
    var C = CAT(), s = C.sizes[size]; spec = s.single ? 'extreme' : spec; var d = s.dome[spec];
    return { v: d.v, na: d.na, kind: 'dome', size: size, title: s.title + (s.single ? '' : ' · ' + C.specs[spec].name), sub: s.dia + ' · ' + (s.single ? 'Maximum-thickness panels' : C.specs[spec].tag), p: d.p, w: d.w, img: G.renderFor(size) };
  };
  G.floorLine = function (size, floor) {
    var C = CAT(), f = C.sizes[size].floors[floor];
    return { v: f.v, na: f.na, kind: 'base', size: size, title: f.title, sub: C.floors[floor].desc, p: f.p, w: f.w, img: G.img(f.img[0], 240) };
  };
  G.shadeLine = function (size, colour) {
    var C = CAT(), s = C.sizes[size], sh = s.shade, l = V[sh.v[colour]];
    return { v: sh.v[colour], na: !(l && l.a), kind: 'shade', size: size, title: s.name + ' sunshade privacy panels', sub: C.colours[colour].name + ' · panels for the back and both sides', p: l ? l.p : sh.p, w: l ? Math.max(l.w, l.p) : sh.w, img: G.shadeRender(size, colour, 'right') };
  };
  /* ---------- Complete Set prices (round 5, option B; amounts and codes in the catalogue's setPricing) ----------
     A Complete Set costs its parts less a fixed set saving, taken off the sunshade; Built for you (base + dome +
     anchoring) bought with a set costs less too. Shown only while setPricing is on, and only in pounds (UK). */
  function SP() { var c = G.CAT && G.CAT.setPricing; return c && c.on && G.uk && G.gbp ? c : null; }
  function r2(n) { return Math.round(n * 100) / 100; }
  G.setSave = function (size) { var c = SP(); return c && c.sets[size] ? c.sets[size].save : 0; };
  G.setBfySave = function (size) { var c = SP(), s = CAT().sizes[size]; return c && s && c.bfy[s.assembly] ? c.bfy[s.assembly].save : 0; };
  /* 23 Oct 2026 (owner): a Complete Set booked with Built for you costs less again, off the base (the Large: its decking) */
  G.setBaseSave = function (size) { var c = SP(); return c && c.base && c.base[size] ? c.base[size].save : 0; };
  /* how the pages say it: 'inc' in a package or tick box, otherwise as a basket or add-on note */
  G.baseSaveTxt = function (size, how) {
    var n = G.setBaseSave(size); if (!n) return '';
    var w = size === 'large' ? 'decking' : 'base';
    return how === 'inc' ? 'Includes ' + G.fmt(n) + ' off the ' + w + '.' : 'With your set, the ' + w + ' costs ' + G.fmt(n) + ' less.';
  };
  /* every code the store owns, so the basket can tell them from codes the shopper typed */
  G.setCodeList = function () {
    var c = G.CAT && G.CAT.setPricing, l = []; if (!c) return l;
    Object.keys(c.sets).forEach(function (k) { l.push(c.sets[k].code); });
    Object.keys(c.bfy).forEach(function (k) { l.push(c.bfy[k].code); });
    if (c.base) Object.keys(c.base).forEach(function (k) { l.push(c.base[k].code); });
    if (c.homeLarge) l.push(c.homeLarge.code);
    return l.map(function (x) { return x.toUpperCase(); });
  };
  /* Built for you bundle variants (base + dome + anchoring): standard, express and extended area */
  function bundleIds(group) {
    var C = CAT(), a = C.assembly[group], e = C.assembly.extended[group], out = [];
    if (a && a.bundle) Object.keys(a.bundle).forEach(function (sp) { out.push(String(a.bundle[sp].v)); });
    if (e && e.bundle) out.push(String(e.bundle.v));
    return out;
  }
  /* a line built in the homepage configurator (V1.3 and V1.4): the homepage sells at full prices, so these lines never
     count towards a Complete Set or its Built for you price (23 Oct 2026, owner: set prices are for the shop only) */
  G.homeLine = function (it) { return !!(it && it.properties && it.properties._gdxs_src === 'home'); };
  /* what the basket holds, per size: domes that take a base, bases, sunshades and Built for you bundles
     (older homepage builds booked a Large build as two Mini/Standard units marked "Dome Size: Large") */
  function tally(items) {
    var n = {}, MS = bundleIds('ministd'), LG = bundleIds('large');
    function bump(k, f, q) { n[k] = n[k] || { dome: 0, base: 0, shade: 0, bfy: 0, home: 0 }; n[k][f] += q; }
    (items || []).forEach(function (it) {
      if (isGift(it) || G.homeLine(it)) return;
      var m = G.meta(it.variant_id), q = it.quantity || 0, id = String(it.variant_id);
      if (m && m.kind === 'dome' && !(m.size === 'mini' && m.spec === 'original')) bump(m.size, 'dome', q);
      else if (m && m.kind === 'base') bump(m.size, 'base', q);
      else if (m && m.kind === 'shade') bump(m.size, 'shade', q);
      if (MS.indexOf(id) > -1) { if (it.properties && it.properties['Dome Size'] === 'Large') bump('large', 'home', q); else bump('ministd', 'bfy', q); }
      else if (LG.indexOf(id) > -1) bump('large', 'bfy', q);
    });
    return n;
  }
  G.setCount = function (items, size) { var x = tally(items)[size]; return x ? Math.min(x.dome, x.base, x.shade) : 0; };
  /* the codes a basket needs: one per size with a complete set, and the Built for you code where a bundle is booked with a set */
  G.setCodesFor = function (items) {
    var c = SP(), out = []; if (!c) return out;
    var n = tally(items);
    function sets(k) { var x = n[k]; return x ? Math.min(x.dome, x.base, x.shade) : 0; }
    ['mini', 'standard', 'large'].forEach(function (k) { if (sets(k) > 0 && c.sets[k]) out.push(c.sets[k].code); });
    /* the base saving: a set of that size and a Built for you bundle of its group (Mini and Standard share one) */
    ['mini', 'standard', 'large'].forEach(function (k) { var g = k === 'large' ? 'large' : 'ministd'; if (sets(k) > 0 && n[g] && n[g].bfy > 0 && c.base && c.base[k]) out.push(c.base[k].code); });
    if (sets('mini') + sets('standard') > 0 && n.ministd && n.ministd.bfy > 0 && c.bfy.ministd) out.push(c.bfy.ministd.code);
    if (sets('large') > 0 && n.large && n.large.bfy > 0 && c.bfy.large) out.push(c.bfy.large.code);
    if (sets('large') > 0 && n.large && n.large.home > 0 && c.homeLarge) out.push(c.homeLarge.code);
    return out;
  };
  /* built: the set is booked with Built for you, so the base carries the base saving too */
  G.set = function (size, spec, floor, colour, built) {
    var lines = [G.domeLine(size, spec)];
    if (floor) lines.push(G.floorLine(size, floor));
    if (colour) lines.push(G.shadeLine(size, colour));
    /* the set saving comes off the sunshade, as it does at checkout. 22 Oct 2026 (owner): pages show the sunshade at its
       full price (full) and the saving once, as a Complete Set saving row; p stays the price the basket charges */
    var off = floor && colour ? G.setSave(size) : 0, sh = lines[lines.length - 1];
    if (off && sh.kind === 'shade' && sh.p > off) { sh.full = sh.p; sh.p = r2(sh.p - off); sh.setSave = off; } else off = 0;
    var boff = built && off ? G.setBaseSave(size) : 0, fl = lines[1];
    if (boff && fl && fl.kind === 'base' && fl.p > boff) { fl.full = fl.p; fl.p = r2(fl.p - boff); fl.setSave = boff; } else boff = 0;
    var t = 0, w = 0, na = false;
    lines.forEach(function (l) { t += l.p || 0; w += l.w || l.p || 0; if (l.na) na = true; });
    return { lines: lines, total: r2(t), was: r2(w), save: r2(w - t), na: na, setSave: off + boff, baseSave: boff };
  };
  /* saving line for empty baskets: the size whose least-saving Complete Set still saves the most, so the claim holds for every set of that size */
  G.setSaveLine = function () {
    var C = CAT(), best = null;
    if (!C || !C.sizeOrder) return '';
    C.sizeOrder.forEach(function (k) {
      var s = C.sizes[k], min = null;
      if (!s || !s.shade || !s.shade.v) return;
      (s.single ? ['extreme'] : C.specOrder).forEach(function (sp) {
        C.floorOrder.forEach(function (f) {
          if (!G.floorAllowed(k, sp, f)) return;
          Object.keys(s.shade.v).forEach(function (c) { var x = G.set(k, sp, f, c); if (!x.na && (min === null || x.save < min)) min = x.save; });
        });
      });
      if (min > 0 && (!best || min > best.save)) best = { size: k, save: min };
    });
    return best ? 'Save ' + G.fmt(best.save) + ' on a ' + C.sizes[best.size].name + ' Complete Set.' : '';
  };
  /* withSet: booked with a Complete Set, so a base + dome + anchoring bundle carries the set saving */
  G.assemblyFor = function (size, scope, speed, zone, withSet) {
    if (!G.uk) return null; /* Built for you is a UK service */
    var C = CAT(), key = C.sizes[size].assembly, a, r;
    if (zone === 'none') return null;
    if (zone === 'extended') {
      if (scope !== 'bundle' && scope !== 'dome') return null;
      a = C.assembly.extended[key][scope];
      r = a ? { v: a.v, na: a.na, p: a.p, w: a.p, speed: 'std' } : null;
    } else {
      a = C.assembly[key][scope] && C.assembly[key][scope][speed || 'std'];
      if (!a) return null;
      r = { v: a.v, na: a.na, p: a.p, w: Math.max(a.w || 0, a.p), speed: speed || 'std' };
    }
    var off = r && withSet && scope === 'bundle' ? G.setBfySave(size) : 0;
    if (off && r.p > off) { r.full = r.p; r.p = r2(r.p - off); r.setSave = off; }
    return r;
  };
  G.SCOPES = {
    bundle: { name: 'Base + dome + anchoring', short: 'Base, dome and anchoring' },
    dome: { name: 'Dome + anchoring', short: 'Dome and anchoring' },
    base: { name: 'Base assembly', short: 'Base only' },
    anchor: { name: 'Anchoring only', short: 'Anchoring only' }
  };
  G.assemblyLine = function (size, scope, speed, zone, withSet) {
    var a = G.assemblyFor(size, scope, speed, zone, withSet); if (!a) return null;
    var C = CAT(), s = C.sizes[size];
    var when = zone === 'extended' ? 'Extended area · within 14 working days' : (a.speed === 'exp' ? 'Express · within 5 working days' : 'Within 14 working days');
    return { v: a.v, na: a.na, kind: 'assembly', size: size, title: 'Built for you · ' + s.name, sub: G.SCOPES[scope].name + ' · ' + when + (a.setSave ? ' · Complete Set price' : ''), p: a.p, w: a.w, full: a.full, setSave: a.setSave, img: G.img(C.assembly.img[0], 240) };
  };
  /* installer coverage by postcode area: the same list the homepage configurator uses
     (plain = standard area, + = extended area at the extended-area prices, anything else = not covered) */
  G.AREAS = (D.assemblyAreas && D.assemblyAreas.length ? D.assemblyAreas : 'AL B BA BB BD BH BL BN BS CB CF CH CM CO CT CV CW DE DN DT DY EX FY GL GU HD HG HP HR HU HX IP L LD LE LL LN LS LU M ME MK NG NN NP NR OL OX PE PO PR RG RH S SG SK SL SN SO SP SS ST SY TA TF TN TQ WA WF WN WR WS WV YO E EC N NW SE SW W WC BR CR DA EN HA IG KT RM SM TW UB WD +CA +LA +NE +DH +SR +TS +DL +SA +DG +TD +EH +ML +G +KA +PA +PL +TR'.split(' '));
  G.coverage = function (pc) {
    var flat = String(pc || '').toUpperCase().replace(/\s+/g, '');
    var m = flat.match(/^([A-Z]{1,2})\d[A-Z\d]?(\d[A-Z]{2})?$/);
    if (!m) return { valid: false };
    var area = m[1], out = flat.length > 4 ? flat.slice(0, -3) : flat;
    if (G.AREAS.indexOf(area) > -1) return { valid: true, zone: 'standard', area: area, out: out };
    if (G.AREAS.indexOf('+' + area) > -1) return { valid: true, zone: 'extended', area: area, out: out };
    return { valid: true, zone: 'none', area: area, out: out };
  };

  /* links written by the page scripts use short page names; map them to store URLs */
  G.href = function (href) {
    var m = String(href || '').match(/^(shop|product|configurator|basket|hospitality|about)\.html(\?[^#]*)?(#.*)?$/);
    if (!m || !G.CAT) return null;
    var C = G.CAT, page = m[1], q = new URLSearchParams((m[2] || '').slice(1)), hash = m[3] || '';
    function withQ(base, keys) {
      var o = new URLSearchParams();
      keys.forEach(function (k) { if (q.get(k)) o.set(k, q.get(k)); });
      var s = o.toString(); return base + (s ? '?' + s : '');
    }
    if (page === 'shop') return C.urls.shop + hash;
    if (page === 'basket') return C.urls.cart;
    if (page === 'hospitality') return C.urls.hospitality + hash;
    if (page === 'about') return C.urls.about + hash;
    if (page === 'configurator') {
      var cq = new URLSearchParams(), SZ = { mini: '27', standard: '35', large: '50' };
      if (q.get('size')) cq.set('size', SZ[q.get('size')] || q.get('size'));
      if (q.get('spec')) cq.set('spec', q.get('spec'));
      if (q.get('floor')) cq.set('base', q.get('floor'));
      if (q.get('colour')) cq.set('shade', q.get('colour'));
      if (q.get('zones')) cq.set('zones', q.get('zones'));
      if (q.get('ar') === '1') cq.set('ar', '1');
      var cs = cq.toString(), cb = C.urls.configurator; return cs ? cb + (cb.indexOf('?') > -1 ? '&' : '?') + cs : cb;
    }
    var id = q.get('id'), size = q.get('size') || 'standard', S = C.sizes[size] || C.sizes.standard;
    if (id === 'set') { q.set('package', 'set'); return withQ(C.urls.dome, ['package', 'size', 'spec', 'floor', 'colour']); }
    if (id === 'dome') return withQ(C.urls.dome, ['size', 'spec']);
    if (id === 'floor') { var f = S.floors[q.get('floor')] || S.floors[Object.keys(S.floors)[0]]; return f.url; }
    if (id === 'shade') return withQ(S.shade.url, ['colour']);
    if (id === 'assembly') return withQ(C.urls.assembly, ['size', 'scope']);
    return C.urls.shop;
  };
  G.fixLinks = function (root) {
    $$('a[href]', root || document).forEach(function (a) {
      var t = G.href(a.getAttribute('href'));
      if (t) a.setAttribute('href', t);
    });
  };
  G.go = function (href) { location.href = G.href(href) || href; };

  /* ---------- boot ---------- */
  function boot() {
    mountShell();
    /* any link to the cart page opens the drawer instead (the cart page itself keeps its link) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      var href = a.getAttribute('href') || '';
      if (href === '#product-selection' && !document.getElementById('product-selection')) {
        e.preventDefault();
        var buy = $('#buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); else location.href = (G.CAT && G.CAT.urls && G.CAT.urls.configurator) || '/';
        return;
      }
      if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?(\?.*)?$/i.test(href) && !a.hasAttribute('data-gdxs-no-drawer') && !document.body.classList.contains('template-cart') && !$('.gdxs-cart-page')) {
        e.preventDefault();
        G.openDrawer();
      }
    }, true);
    G.cart.fetch().catch(function () { });
    G.fixLinks(document);
    if ('MutationObserver' in window) {
      /* new links, and links whose href a page script changes later (card Details and 3D buttons), always point at store URLs */
      new MutationObserver(function (list) {
        list.forEach(function (r) {
          if (r.type === 'attributes') { var a = r.target, u = a.matches && a.matches('a[href]') && G.href(a.getAttribute('href')); if (u) a.setAttribute('href', u); return; }
          r.addedNodes && Array.prototype.forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('a[href]')) { var t = G.href(n.getAttribute('href')); if (t) n.setAttribute('href', t); } G.fixLinks(n); } });
        });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
  }
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
